import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TasksFilterComponent } from '../tasks-filter/tasks-filter.component';
import { StoreService } from '../store.service';

const DEBUG = false;

@Component({
  selector: 'app-tasks-filter-button',
  templateUrl: './tasks-filter-button.component.html',
  styleUrls: ['./tasks-filter-button.component.scss']
})
export class TasksFilterButtonComponent {

  constructor(public dialog: MatDialog, private store: StoreService) { }

  showFilter(): void {
    if (DEBUG) {console.log('TasksFilter showFilter()');}

    const dialogRef = this.dialog.open(TasksFilterComponent, {
      width: '600px',
      data: Object.assign(this.store.filter)
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (DEBUG) {console.log('TasksFilter afterClosed()');}
      if (data) {
        if (DEBUG) {console.log('TasksFilter returned data', data);}
        this.store.updateFilter(data);
      }
    });
  }

}
